import { QUERY_FEATURE_FLAG } from '../constants/query-params/feature-flags';
import isProduction from './is-production';
import serializeQueryParams from './url/serialize-query-params';


type QualityEventDebugPayload = {
    type?: string;
    extra?: unknown;
    [key: string]: unknown;
};

const SESSION_KEY = 'qeDebug';
const ENABLE_VALUES = ['1', 'true', 'on'];
const DISABLE_VALUES = ['0', 'false', 'off'];
const UNTYPED_EVENT_KEY = 'unknown';

const readSessionFlag = (): boolean => {
    try {
        return window.sessionStorage.getItem(SESSION_KEY) === 'true';
    } catch (e) {
        return false;
    }
};

const writeSessionFlag = (isEnabled: boolean) => {
    try {
        if (isEnabled) {
            window.sessionStorage.setItem(SESSION_KEY, 'true');

            return;
        }

        window.sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {
    }
};

const parseExtra = (extra: unknown) => {
    if (typeof extra !== 'string') {
        return extra;
    }

    try {
        return JSON.parse(extra);
    } catch (e) {
        return extra;
    }
};

const qualityEventsDebug = {
    isEnabled(): boolean {
        return !isProduction() && readSessionFlag();
    },

    on() {
        writeSessionFlag(true);
    },

    off() {
        writeSessionFlag(false);
    },

    log(payload: QualityEventDebugPayload[]) {
        if (!this.isEnabled()) {
            return;
        }

        payload.forEach((event) => {
            console.info({ [event.type ?? UNTYPED_EVENT_KEY]: { ...event, extra: parseExtra(event.extra) } });
        });
    }
};

export const initQualityEventsDebug = () => {
    if (isProduction()) {
        return;
    }

    const flagValue = serializeQueryParams()[QUERY_FEATURE_FLAG.QE_DEBUG];

    if (flagValue !== undefined) {
        const normalizedValue = String(flagValue).toLowerCase();

        if (ENABLE_VALUES.includes(normalizedValue)) {
            writeSessionFlag(true);
        }

        if (DISABLE_VALUES.includes(normalizedValue)) {
            writeSessionFlag(false);
        }
    }

    window.qeDebug = qualityEventsDebug;
};

export default qualityEventsDebug;
